<template>
  <section class="hero">
    <div id="headline" class="headline">{{ headline }}</div>
    <div class="grid">
      <div class="grid__item" style="transform: scale(1);"></div>
    </div>
  </section>
</template>
<script>
  import anime from "animejs"
  export default {
    name: "hero",
    props: ["headline"],
    data() {
      return {
        newText: "",
      }
    },
    mounted() {
      this.$nextTick(function() {
        // Code that will run only after the entire view has been rendered
        this.createGrid()
        anime({
          targets: ".grid__item",
          scale: [
            { value: 0.1, easing: "easeOutSine", duration: 500 },
            { value: 1, easing: "easeInOutQuad", duration: 1200 },
          ],
          // rotate: {
          //   value: ["0", "-23"],
          //   easing: "easeInOutQuad",
          //   duration: 1200,
          // },
          borderRadius: {
            value: ["0", "4px", "0"],
            easing: "easeInOutQuad",
            duration: 1200,
          },
          backgroundColor: [
            {
              value: ["#333", "#444"],
              easing: "easeInOutQuad",
              duration: 1200,
            },
          ],
          delay: anime.stagger(200, { grid: [60, 11], from: "center" }),
          loop: true,
          direction: "alternate",
        })
      })
    },
    methods: {
      createGrid: async function() {
        for (var i = 0; i < 2000; i++) {
          this.newText +=
            "<div class='grid__item' style='transform: scale(1);'></div>"
        }
        document.querySelector(".grid").innerHTML = this.newText
      },
    },
  }
</script>
<style lang="scss">
  @import "./src/scss/style--light";

  .grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .grid__item {
    pointer-events: none;
    position: relative;
    width: 22px;
    height: 22px;
    margin: 1px;
    background-color: rgba(51, 51, 51, 0.8);
    font-size: 14px;
    border-radius: 0;
    background-image: url("/img/bg-grid.svg");
  }

  .grid__item::before {
    content: "";
    display: block;
    width: 2px;
    height: 2px;
    background-color: rgba(var(--background-secondary), 1);
    position: relative;
    top: -2px;
    left: -2px;
  }

  .headline {
    position: absolute;
    display: flex;
    z-index: 10;
  }
</style>
